import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const solutionDilutionTool: Tool = {
  id: "solution-dilution",
  name: () => m.soldil_tool_name(),
  description: () => m.soldil_tool_description(),
  icon: "🧪",
  basePath: "/solution-dilution",
  status: "stable",
  tags: ["calculator", "chemistry", "science", "lab", "dilution", "molarity"],
};
